import { useApi } from './useApi'

export interface ProjectGrant {
  clientId: number
  role: 'owner' | 'editor' | 'viewer'
  modules: string[]
}

interface User {
  id: number
  email: string
  name: string
  picture: string | null
  role: string
  status: string
  grants: ProjectGrant[]
}

export function useCurrentUser() {
  const { data, loading } = useApi<{ user: User }>('/api/auth/me')
  const role = data?.user?.role
  const isSuperAdmin = role === 'super_admin'
  return {
    user: data?.user ?? null,
    loading,
    isAdmin: role === 'admin' || isSuperAdmin,
    isSuperAdmin,
    isPending: data?.user?.status === 'pending',
    isBlocked: data?.user?.status === 'blocked',
    grants: data?.user?.grants ?? [],
  }
}
